module.exports = __webpack_public_path__ + "9fa3d0cdebf1206287b85fc7fdec7e25.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/abbvie_2023_chart.png
// module id = 1620
// module chunks = 0